import React from 'react';

import pdf1 from '../images/thumb1.png'; 
import pdf2 from '../images/thumb2.png';
import pdfFile3 from '../pdf/AnnualReport2023-24.pdf'; // Adjust the path as necessary
import pdfFile4 from '../pdf/AnnualReportGST2023.pdf';


const AnnualReport = () => {
  return (
   <>

<section className="our-story-section inner-page">
            <div className="container">
                <h1>Annual Report </h1>
     
    <div className='row'>
    <div className='col-md-3'>
     <a target="_blank" href={pdfFile4} > <img className='pdfimg' src={pdf1} alt=""></img></a>
     <h6>Annual Report 2022-2023 </h6>

</div>
<div className='col-md-3'>
<a  target="_blank" href={pdfFile3}  > <img className='pdfimg' src={pdf2} alt=""></img></a>
<h6>Annual Report 2023-2024 </h6>

</div>

    </div>
      </div>
      
     
      <br></br>
        
      <br></br>
        
      <br></br>
     
      </section>
   
   </>
   );
  };
 

export default AnnualReport
